import { render, staticRenderFns } from "./ValidProduct.vue?vue&type=template&id=7ce4d57c"
import script from "./ValidProduct.vue?vue&type=script&lang=js"
export * from "./ValidProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports